import angular from 'angular';
import notfoundComponent from './notfound.component';

let notFoundModule = angular.module('notfound', [])

.config(($stateProvider) => {
  "ngInject";

  // $stateProvider
  //   .state('notfound', {
  //     url: '/404',
  //     template: '<notfound></notfound>'
  //   });
})

.component('notfound', notfoundComponent);

export default notFoundModule;



// WEBPACK FOOTER //
// ./client/pages/404/notfound.js